import * as React from 'react';

function SvgBorderAdd(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.469 1.376H6.53c-.083 0-.125.042-.125.125v4.906H1.75c-.083 0-.125.042-.125.125v.938c0 .083.042.125.125.125h4.656V12.5c0 .083.042.125.125.125h.938c.083 0 .125-.042.125-.125V7.595h4.656c.084 0 .125-.042.125-.125v-.938c0-.083-.041-.125-.125-.125H7.594V1.501c0-.083-.042-.125-.125-.125z"
        fill="#"
      />
    </svg>
  );
}

export default SvgBorderAdd;
